// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"b96aa2107c0fdeea","284":"5736d0b53bd62ee2","409":"22664513c6d5f4eb","626":"5736d0b53bd62ee2","931":"5736d0b53bd62ee2"}[chunkId] + ".css";
};